import React, { useEffect } from 'react';
import { StyledButton } from "./styles";

export const FunctionalButtonImage =({
    buttonTitle,
    normalImage,
    hoverImage,
    handleButton,
    width,
    height,
    backgroundColor,
    isReversedColor,
    marginRight,
    marginLeft,
    marginTop,
    marginBottom,
    fontSize,
    disabled,
    icon,
    hasBoxShadow,
    frontIcon,
    weight,
    borderColor,
    selected,
}) => {

    return (
        <StyledButton
            onClick={ handleButton }
            width={width}
            normalImage={normalImage}
            hoverImage={hoverImage}
            height={height}
            backgroundColor={backgroundColor}
            isReversedColor={isReversedColor}
            marginRight={marginRight}
            marginLeft={marginLeft}
            marginTop={marginTop}
            marginBottom={marginBottom}
            fontSize={fontSize}
            disabled={disabled}
            hasBoxShadow={hasBoxShadow}
            weight={weight}
            borderColor={borderColor}
            selected={selected}
        >
            {frontIcon && (
            <>{icon}</>
            )}
            {buttonTitle}
            {!frontIcon && (
            <>{icon}</>
            )}
        </StyledButton>
    )
}

